export { default } from "./AnchorTarget";
